import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * WI 58: shared US phone validation + normalization, mirroring the backend
 * RegistrationValidation helper so client and server enforce the same rule.
 */

/** Strip every non-digit character. */
export function normalizePhoneDigits(phone: string | null | undefined): string {
  if (!phone) {
    return '';
  }
  return phone.replace(/\D/g, '');
}

/**
 * A valid US phone is 10 digits after normalization, or 11 digits with a leading
 * country code '1'.
 */
export function isValidUsPhone(phone: string | null | undefined): boolean {
  const digits = normalizePhoneDigits(phone);
  if (digits.length === 10) {
    return true;
  }
  return digits.length === 11 && digits.charAt(0) === '1';
}

/**
 * Returns the canonical 10-digit US phone to send/persist, or null if invalid.
 * Drops a leading country-code '1' from 11-digit input.
 */
export function normalizeUsPhone(phone: string | null | undefined): string | null {
  let digits = normalizePhoneDigits(phone);
  if (digits.length === 11 && digits.charAt(0) === '1') {
    digits = digits.substring(1);
  }
  return digits.length === 10 ? digits : null;
}

/** Reactive-forms validator for a required, valid US phone. */
export function usPhoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return { required: true };
    }
    return isValidUsPhone(value) ? null : { usPhone: true };
  };
}
